export default "__VITE_ASSET__CII8w5$b__"